import request from '@/utils/request'

// 获取会员列表数据
export async function api_getListMember(params) {
  return request({
    url: '/rest/member/page',
    method: 'get',
    params,
  })
}
// 会员选择器(分页)
export async function api_getMemberSelect(params) {
  return request({
    url: '/rest/member/loadMore',
    method: 'get',
    params,
  })
}
// 会员选择器(不分页)
export async function api_getMemberSelectAll() {
  return request({
    url: '/rest/member/loadAll',
    method: 'get',
  })
}

// 获取会员等级
export async function api_getListLevel(params) {
  return request({
    url: '/rest/member/config/level/page',
    method: 'get',
    params,
  })
}
// 获取会员详情
export async function api_getMemberDetail(params) {
  return request({
    url: '/rest/member',
    method: 'get',
    params,
  })
}
// 获取会员权益列表
export async function api_getPageBenefit(params) {
  return request({
    url: '/rest/member/config/benefit/page',
    method: 'get',
    params,
  })
}
// 获取会员画像列表
export async function api_getListPortrait(params) {
  return request({
    url: '/rest/member/config/portrait/page',
    method: 'get',
    params,
  })
}
// 按画像导出会员
export async function api_postExportMemberByPortrait(data) {
  return request({
    url: '/crm/exportMemberByPortrait',
    method: 'post',
    data,
  })
}
// 调整等级
export async function api_putULevel(data) {
  return request({
    url: '/rest/member/level',
    method: 'put',
    data,
  })
}
// 调整积分
export async function api_putUPoint(data) {
  return request({
    url: '/rest/member/point',
    method: 'put',
    data,
  })
}
// 调整等级
export async function api_putULevels(data) {
  return request({
    url: '/rest/member/levels',
    method: 'put',
    data,
  })
}
// 调整积分
export async function api_putUPoints(data) {
  return request({
    url: '/rest/member/points',
    method: 'put',
    data,
  })
}
// 创建画像
export async function api_postPortrait(data) {
  return request({
    url: '/rest/member/config/portrait',
    method: 'post',
    data,
  })
}
// 编辑画像
export async function api_putPortrait(data) {
  return request({
    url: '/rest/member/config/portrait',
    method: 'put',
    data,
  })
}
// 删除画像
export async function api_deletePortrait(params) {
  return request({
    url: '/rest/member/config/portrait',
    method: 'delete',
    params,
  })
}
// 获取画像详情
export async function api_getPortrait(params) {
  return request({
    url: '/rest/member/config/portrait',
    method: 'get',
    params,
    loading: true
  })
}
// 创建权益
export async function api_postMemberBenefit(data) {
  return request({
    url: '/rest/member/config/benefit',
    method: 'post',
    data,
  })
}
// 编辑权益
export async function api_putMemberBenefit(data) {
  return request({
    url: '/rest/member/config/benefit',
    method: 'put',
    data,
  })
}
// 删除权益
export async function api_deleteMemberBenefit(params) {
  return request({
    url: '/rest/member/config/benefit',
    method: 'delete',
    params,
  })
}
// 获取权益详情
export async function api_getMemberBenefit(params) {
  return request({
    url: '/rest/member/config/benefit',
    method: 'get',
    params,
    loading: true
  })
}
// 会员等级详情
export async function api_getMemberLevel(params) {
  return request({
    url: '/rest/member/config/level',
    method: 'get',
    params,
    loading: true
  })
}
// 会员等级排序
export async function api_getMemberSortIndex(params) {
  return request({
    url: '/rest/member/config/sortIndex',
    method: 'get',
    params
  })
}
// 创建等级
export async function api_postMemberLevel(data) {
  return request({
    url: '/rest/member/config/level',
    method: 'post',
    data
  })
}
// 编辑等级
export async function api_putMemberLevel(data) {
  return request({
    url: '/rest/member/config/level',
    method: 'put',
    data
  })
}
// 删除等级
export async function api_deleteMemberLevel(params) {
  return request({
    url: '/rest/member/config/level',
    method: 'delete',
    params
  })
}
// 标签列表--分页
export async function api_getLabelPage(params) {
  return request({
    url: '/rest/member/config/label/page',
    method: 'get',
    params
  })
}
// 创建标签
export async function api_postCreateLabel(data) {
  return request({
    url: '/rest/member/config/label',
    method: 'post',
    data
  })
}
// 编辑标签
export async function api_putCreateLabel(data) {
  return request({
    url: '/rest/member/config/label',
    method: 'put',
    data
  })
}
// 删除标签
export async function api_deleteLabel(params) {
  return request({
    url: '/rest/member/config/label',
    method: 'delete',
    params
  })
}
// 获取标签详情
export async function api_getLabel(params) {
  return request({
    url: '/rest/member/config/label',
    method: 'get',
    params
  })
}
// 通过画像打标签
export async function api_postPortraitLabel(data) {
  return request({
    url: '/rest/member/portrait/labeled',
    method: 'post',
    data
  })
}
// 删除画像
export async function api_deleteUserLabel(params) {
  return request({
    url: '/rest/member/config/user/label',
    method: 'delete',
    params,
  })
}
// 删除会员标签
export async function api_postDeleteLabeled(params) {
  return request({
    url: '/rest/member/deleteLabeled',
    method: 'post',
    params
  })
}
export async function api_postMemberExport(data) {
  return request({
    url: 'rest/member/export',
    method: 'post',
    data,
    responseType: 'blob',
  })
}
//等级记录列表
export async function api_getMemberRecordList(params) {
  return request({
    url: 'rest/member/level/record',
    method: 'get',
    params
  })
}
//等级记录导出
export async function api_postMemberRecordExport(data) {
  return request({
    url: 'rest/member/level/record/export',
    method: 'post',
    data,
    responseType: 'blob',
  })
}

/************************************会员营销数据*******************************************/
//会员销售数据列表
export async function api_getMemberSaleDataList(params) {
  return request({
    url: '/rest/member/sale/data/member',
    method: 'get',
    params
  })
}
//会员销售数据导出
export async function api_getMemberSaleDataExport(params) {
  return request({
    url: '/rest/member/sale/data/member/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

//会员卡，积分数据列表
export async function api_getMemberSaleDataPointList(params) {
  return request({
    url: '/rest/member/sale/data/member/point',
    method: 'get',
    params
  })
}
//会员卡，积分数据导出
export async function api_getMemberSaleDataPointExport(params) {
  return request({
    url: '/rest/member/sale/data/member/point/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

//男女比例数据列表
export async function api_getMemberSaleDataSexList(params) {
  return request({
    url: '/rest/member/sale/data/member/sex',
    method: 'get',
    params
  })
}
//男女比例数据导出
export async function api_getMemberSaleDataSexExport(params) {
  return request({
    url: '/rest/member/sale/data/member/sex/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

//年龄数据列表
export async function api_getMemberSaleDataAgeList(params) {
  return request({
    url: '/rest/member/sale/data/member/age',
    method: 'get',
    params
  })
}
//年龄数据导出
export async function api_getMemberSaleDataAgeExport(params) {
  return request({
    url: '/rest/member/sale/data/member/age/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

//券分销数据导出
export async function api_getCouponDistributionDataExport(params) {
  return request({
    url: '/rest/market/coupon/share/data/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}
